import Tooltip from 'LuxKit/Tooltip'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import FilterChip from 'LuxKit/Chips/FilterChip'
import Group from 'components/utils/Group'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Modal from 'LuxKit/Modal/Modal'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import useCarHireLabels from 'hooks/CarHire/useCarHireLabels'
import ModalContext from 'contexts/ModalContext'
import noop from 'lib/function/noop'
import { useCallback, useContext } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  value?: App.CarHireDriverAgeCategory
  onChange?: (category: App.CarHireDriverAgeCategory) => void
}

function CarHireSearchDriversAgeCategorySelect(props: Props) {
  const { value, onChange = noop } = props
  const intl = useIntl()
  const { driverCategories } = useCarHireLabels()

  const onSelectDriversAge = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    if (e.currentTarget.dataset.category) {
      const nextCategory = parseInt(e.currentTarget.dataset.category) as App.CarHireDriverAgeCategory
      onChange(nextCategory)
    }
  }, [onChange])

  const driversAgeTitle = intl.formatMessage({
    id: 'BTJn_ZAdCwvvmdpJchT8',
    defaultMessage: 'Driver’s age',
    description: 'Title for driver age selection section in car hire search',
  })

  const driversAgeDescription = intl.formatMessage({
    id: 'xQSg5Y2rlno67sb9RD_7',
    defaultMessage: 'Ensure the driver’s age aligns with your pick-up date for accurate pricing.',
    description: 'Tooltip description explaining why driver age matters for car hire pricing',
  })

  const showModal = useContext(ModalContext)
  const onViewDriversAgeTooltip = () => {
    showModal(<Modal title={driversAgeTitle}>
      <BodyText variant="medium">
        {driversAgeDescription}
      </BodyText>
    </Modal>)
  }

  return <Group direction="horizontal" verticalAlign="center" gap={16}>
    {/* mobile */}
    <CSSBreakpoint max="tablet">
      <CaptionTextBlock onClick={onViewDriversAgeTooltip} variant="large" endIcon={<LineInfoCircleIcon />}>
        {driversAgeTitle}
      </CaptionTextBlock>
    </CSSBreakpoint>

    {/* desktop */}
    <CSSBreakpoint min="desktop">
      <Tooltip description={driversAgeDescription}>
        <CaptionTextBlock variant="large" endIcon={<LineInfoCircleIcon />}>
          {driversAgeTitle}
        </CaptionTextBlock>
      </Tooltip>
    </CSSBreakpoint>

    <Group direction="horizontal" gap={4}>
      {driverCategories.map(cat =>
        <FilterChip
          key={cat.id}
          size="medium"
          selected={value === cat.id}
          data-category={cat.id}
          onClick={onSelectDriversAge}
        >
          {cat.label}
        </FilterChip>,
      )}
    </Group>
  </Group>
}

export default CarHireSearchDriversAgeCategorySelect
